export const environment = {
    BASE_URL: 'https://oblation.test.satsang.org.in',
    //BASE_URL: 'http://localhost:5001',
    SSO_URL: 'https://sso2.test.satsang.org.in/',
    //localhostUrl: 'http://localhost:4200/login',  // [USE IT FOR DEVELOPMENT BUT NEVER PUSH]
    localhostUrl: '',
    orgUrl: 'https://www.test.satsang.org.in',
    accoUrl: 'https://dev.acco.satsang.org.in',
    activityLogoutTimeInMins: 10,
    razorpay_key: 'rzp_test_R8pAzIKa5zsWhV',
    production: false,
};
